import { VuexModule, mutation, Module, action } from 'vuex-class-component';

@Module({ namespacedPath: 'user/' })
export class UserStore extends VuexModule {
    // ユーザID
    private _user_id: number = 0;
    get user_id() {
        return this._user_id;
    }
    @mutation
    private setUserId(value: number) {
        this._user_id = value;
    }
    @action
    public async setUserIdAc(value: number) {
        this.setUserId(value);
    }

    // ユーザアカウント
    private _user_account: string = '';
    get user_account() {
        return this._user_account;
    }
    @mutation
    private setUserAccount(value: string) {
        this._user_account = value;
    }
    @action
    public async setUserAccountAc(value: string) {
        this.setUserAccount(value);
    }

    // ユーザ名
    private _user_name: string = '';
    get user_name() {
        return this._user_name;
    }
    @mutation
    private setUserName(value: string) {
        this._user_name = value;
    }
    @action
    public async setUserNameAc(value: string) {
        this.setUserName(value);
    }

    // 会社ID
    private _corp_id: number = 0;
    get corp_id() {
        return this._corp_id;
    }
    @mutation
    private setCorpId(value: number) {
        this._corp_id = value;
    }
    @action
    public async setCorpIdAc(value: number) {
        this.setCorpId(value);
    }

    // ユーザ権限
    private _authority: number = 0;
    get authority() {
        return this._authority;
    }
    @mutation
    private setAuthority(value: number) {
        this._authority = value;
    }
    @action
    public async setAuthorityAc(value: number) {
        this.setAuthority(value);
    }

    // アクセストークン
    private _token: string = '';
    get token() {
        return this._token;
    }
    @mutation
    private setToken(value: string) {
        this._token = value;
    }
    @action
    public async setTokenAc(value: string) {
        this.setToken(value);
    }

    // 一括セット
    @action
    public async setParamAc(value: {
        user_id: number;
        user_account: string;
        user_name: string;
        authority: number;
        corp_id: number;
    }) {
        this.setUserId(value.user_id);
        this.setUserAccount(value.user_account);
        this.setUserName(value.user_name);
        this.setAuthority(value.authority);
        this.setCorpId(value.corp_id);
    }

    // 初期化
    @action
    public async initializeParamAc() {
        this.setUserId(0);
        this.setUserAccount('');
        this.setUserName('');
        this.setAuthority(0);
        this.setToken('');
        this.setCorpId(0);
    }
}
